<template>
  <div class="poster">
    <div class="poster-header">
      <img class="poster-header__logo" src="@/assets/imgs/poster/logo.png" />
      <div class="poster-header__title">ShanghaiEye</div>
      <img class="poster-header__star" src="@/assets/imgs/poster/star.png" />
    </div>
    <div class="poster-content">
      <div class="poster-content__cover">
        <img class="cover" :src="postinfo.imgUrl" />
      </div>
      <div class="poster-content__title">{{ postinfo.postTitle }}</div>
      <div class="poster-content__footer">
        <img
          class="footer-qrcode"
          :src="postinfo.codeImgUrl"
        />
      </div>
    </div>
    <!-- <div class="img-box">
        <img :src="postinfo.imgUrl"  alt="">
    </div>
    <div class="btn-box">
        <span v-for="(item,index) in postinfo.tagsName" :key="index" v-if="index<1">{{item}}</span>
    </div>
    <div class="article">
        <div class="article-title">
           {{postinfo.postTitle}}
        </div>
        <div class="article-content">
            {{postinfo.posterDescription}}
        </div>
    </div>
    <div class="ewm">
        <div class="ewm-box">
            <img :src="postinfo.codeImgUrl" alt="" width="100%">
        </div>
        <div class="press">Long press the QR code for details</div>
    </div>
    <div class="footer">
        <img src="@/assets/imgs/detial/poster_logo.png"  alt="">
    </div> -->
  </div>
</template>
<script>
import { getPoserData } from "@/network/details.js";
export default {
  name: "Poster",
  data() {
    return {
      postId: "",
      flag: "",
      postinfo: "",
    };
  },
  mounted() {
    this.postId = this.$route.query.postId;
    this.flag = this.$route.query.flag;
    this.getPoserData();
  },
  methods: {
    getPoserData() {
      getPoserData({ postId: this.postId, flag: this.flag }).then((res) => {
        if (res.code == 200) {
          // console.log(res)
          this.postinfo = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.poster {
  width: 100%;
  position: fixed;
  // height: 100vh;
  display: flex;
  flex-direction: column;
  //   background: #ccc;
  &-header {
    padding: 0.36rem 0.37rem 0.23rem;
    background: #fff;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 99;
    &__logo {
      width: 0.9rem;
      height: 0.9rem;
    }
    &__star {
      width: 0.36rem;
      height: 0.31rem;
    }
    &__title {
      font-family: AcuminConcept-SemiCondensedBlack, AcuminConcept;
      font-weight: bold;
      color: #000000;
      margin: 0 0.1rem 0 0.3rem;
      font-size: 0.44rem;
    }
  }
  &-content {
    // flex: 1;
    background: url("~@/assets/imgs/poster/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    &__cover {
      // width: 10.08rem;
      // height: 5.66rem;
      // margin: 0 0.38rem;
      margin: 23px 13px;
      // max-height: 226px;
      aspect-ratio: 16 / 9;
      .cover {
        width: 100%;
        height: 100%;
      }
    }
    &__title {
      margin: 0.5rem 0.46rem 0;
      font-size: 30px;
      font-family: HYZhongSongS;
      color: #000000;
      flex: 1;
      font-weight: bold;
      white-space: pre-line;
    }
    &__footer {
      padding: 0.5rem;
      text-align: right;
      .footer-qrcode {
        width: 1.12rem;
        height: 1.12rem;
      }
    }
  }
  .img-box {
    width: 100%;
    height: auto;
    padding: 10px 20px 5px 20px;
    img {
      width: 100%;
      height: auto;
      max-height: 188px;
    }
  }
  .btn-box {
    background: #333;
    color: #ffffff;
    width: 95px;
    border-radius: 3px;
    text-align: center;
    margin: 5px 20px;
    font-size: 12px;
    padding: 3px 0;
  }
  .article {
    font-size: 20px;
    padding: 0 20px;
    .article-title {
      font-size: 20px;
      font-family: FranklinGothic-Demi;
      font-weight: bold;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      line-clamp: 3;
    }
    .article-content {
      font-family: Open Sans;
      font-size: 12px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      line-clamp: 5;
    }
  }
  .ewm {
    text-align: center;
    .ewm-box {
      height: 87px;
      width: 87px;
      margin: 15px auto;
      background: #666666;
    }
    .press {
      font-size: 12px;
      padding: 0 20px;
      font-family: Open Sans;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #565656;
    height: 48px;
    text-align: center;
    line-height: 32px;
    img {
      width: 97px;
      height: 21px;
      margin: 0 auto;
    }
  }
}
</style>
